<template>
  <div>
    <MapNomads
      v-if="contentLoaded"
      :map-markers="mapMarkers"
      :options="{mode:'user'}"
    />
  </div>
</template>

<script>
import MapMarker from '@/vuex/orm/models/MapMarker';

export default {
  name: 'PageMap', // important

  components: {
    MapNomads: () => import('@/components/map/MapNomads'),
  },

  data() {
    return {
      contentLoaded: false,
      mapMarkers: [],
    };
  },

  created() {
    this.loadMapMarkers();
  },

  mounted() {
    Bus.$on('map-markers:loaded', () => {
      this.loadMapMarkers();
    });

    Bus.$on('map-markers:refreshed', () => {
      this.loadMapMarkers();
    });
  },

  activated() {
    console.log('activated');
  },
  deactivated() {
    console.log('deactivated');
  },

  beforeDestroy() {
    Bus.$off('map-markers:loaded');
    Bus.$off('map-markers:refreshed');
  },

  methods: {
    async loadMapMarkers() {
      // this.mapMarkers = MapMarker.query().get();

      await this.$http
        .get('/api/admin/map/nomads', {
          params: {},
        })
        .then((response) => {
          // console.log('response', response.data);
          this.mapMarkers = response.data;
        });


      console.log('map-markers.count', this.mapMarkers.length);

      if (this.mapMarkers.length) {
        this.contentLoaded = true;
      }
    },
  },
};
</script>
